module.exports = __webpack_public_path__ + "img/banner_plate_2.48fc852d.png";